export default __webpack_public_path__ + "static/media/custom3b.1be1159a.png";